import { IMAGE_TYPE, IMAGE_DISPLAY_NAME } from './imageConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';

const objectConstructorFn = (params) => {
    const { content } = params;
    return {
        ...elementConstructor(params),
        elementType: IMAGE_TYPE,
        content: {
            image: null,
            ...content,
        },
    };
};

export default (params = {}) =>
    registerElementType({
        elementType: IMAGE_TYPE,
        objectConstructorFn,
        displayName: IMAGE_DISPLAY_NAME,
        ...params,
    });
